<template>
	<div>
		<iframe
			:src=iframeLink
			frameborder="0"
			style="
				overflow: hidden;
				overflow-x: hidden;
				overflow-y: hidden;
				height: 80%;
				width: 80%;
				position: absolute;
			"
			height="150%"
			width="150%"
		></iframe>
	</div>
</template>
<script>
export default {
	data() {
		return {
			iframeLink: null,
		};
	},
	mounted() {
		this.getProjectList();
	},
	methods: {
		async getProjectList() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.MENU_LIST + '?p=' + this.$STORE.state.userConfig.setProjectId + '&is_active=true' + '&has_iframe=true' + '&frontend_route_url=/dashboard',
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.iframeLink = res.data[0].iframe_link;
			}
		},
       
	},
};
</script>